import { createAsyncThunk } from '@reduxjs/toolkit'
import { MASTER_DATA_URLS } from '../../../configs/api'
import { AxiosService } from '../../../services/api'
import { createThunkName } from '../../../utils/createThunkname'
import {
  GetAllCountriesQueryParams,
  GetAllCountriesResponse,
  GetAllRegionsResponse,
  GetBeneficiariesMasterDataResponse,
  GetDealerMasterDataResponse,
  GetDistrictMasterDataQueryParams,
  GetDistrictMasterDataResponse,
  GetFlightsMasterDataResponse,
  GetNationalityMasterDataResponse,
  GetOccupationsMasterDataQueryParams,
  GetOccupationsMasterDataResponse,
  GetPrefixesMasterDataResponse,
  GetProvinceMasterDataResponse,
  GetSubDistrictMasterDataQueryParams,
  GetSubDistrictMasterDataResponse
} from './types'

const PREFIX = 'masterData'

export const MasterDataService = {
  getAllRegionsAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getAllRegions'), async () => {
    try {
      const result = await AxiosService.get<GetAllRegionsResponse>(MASTER_DATA_URLS.getAllRegions)
      return result.data.regions
    } catch (error) {
      throw error
    }
  }),
  getAllCountriesAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getAllCountries'),
    async (queryParams: GetAllCountriesQueryParams) => {
      try {
        const result = await AxiosService.get<GetAllCountriesResponse>(MASTER_DATA_URLS.getAllCountries, {
          params: queryParams
        })
        return result.data.countries
      } catch (error) {
        throw error
      }
    }
  ),
  getAllProvinceMasterDataAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getProvinceMasterData'), async () => {
    try {
      const result = await AxiosService.get<GetProvinceMasterDataResponse>(MASTER_DATA_URLS.getProvinceMasterData)
      return result.data.provinces
    } catch (error) {
      throw error
    }
  }),
  getAllDistrictMasterDataAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getDistrictMasterData'),
    async (queryParams: GetDistrictMasterDataQueryParams) => {
      try {
        const result = await AxiosService.get<GetDistrictMasterDataResponse>(MASTER_DATA_URLS.getDistrictMasterData, {
          params: queryParams
        })
        return result.data.districts
      } catch (error) {
        throw error
      }
    }
  ),
  getAllSubDistrictMasterDataAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getSubDistrictMasterData'),
    async (queryParams: GetSubDistrictMasterDataQueryParams) => {
      try {
        const result = await AxiosService.get<GetSubDistrictMasterDataResponse>(
          MASTER_DATA_URLS.getSubDistrictMasterData,
          { params: queryParams }
        )
        return result.data.subDistricts
      } catch (error) {
        throw error
      }
    }
  ),
  getAllNationalitiesMasterDataAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getNationalityMasterData'),
    async () => {
      try {
        const result = await AxiosService.get<GetNationalityMasterDataResponse>(
          MASTER_DATA_URLS.getNationalityMasterData
        )
        return result.data.nationalities
      } catch (error) {
        throw error
      }
    }
  ),
  getAllPrefixesMasterDataAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getPrefixMasterData'), async () => {
    try {
      const result = await AxiosService.get<GetPrefixesMasterDataResponse>(MASTER_DATA_URLS.getPrefixMasterData)
      return result.data.prefixes
    } catch (error) {
      throw error
    }
  }),
  getAllBeneficiariesMasterDataAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getBeneficiariesMasterData'),
    async () => {
      try {
        const result = await AxiosService.get<GetBeneficiariesMasterDataResponse>(
          MASTER_DATA_URLS.getBeneficiariesMasterData
        )
        return result.data.beneficiaries
      } catch (error) {
        throw error
      }
    }
  ),
  getAllFlightsMasterDataAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getFlightsMasterData'), async () => {
    try {
      const result = await AxiosService.get<GetFlightsMasterDataResponse>(MASTER_DATA_URLS.getFlightsMasterData)
      return result.data.flightList
    } catch (error) {
      throw error
    }
  }),
  getOccupationsMasterDataAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getOccupationsMasterData'),
    async (queryParams: GetOccupationsMasterDataQueryParams) => {
      try {
        const result = await AxiosService.get<GetOccupationsMasterDataResponse>(
          MASTER_DATA_URLS.getOccupationsMasterData,
          {
            params: queryParams
          }
        )
        return result.data.occupationList
      } catch (error) {
        throw error
      }
    }
  ),
  getDealerMasterDataAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getDealerMasterData'), async () => {
    try {
      const result = await AxiosService.get<GetDealerMasterDataResponse>(MASTER_DATA_URLS.getDealerMasterData)
      return result.data.dealerList
    } catch (error) {
      throw error
    }
  })
}
